import { EventType } from './../core/apiTypes';
import envConfig from '../config/currentEnv';
import { Animation, IconAxel, IconCommon, IconError, IconLogo, IconService, ImageEvent } from '../resources/images';

const logoEnv: string | undefined = process.env.REACT_APP_LOGO;

export const iconToCdn = (
    icon: IconLogo | IconCommon | IconAxel | IconService | IconError,
    darkMode: boolean = false,
): string => {
    const srcBase = envConfig.currentEnv.cdnURL;
    let src = srcBase;

    if (Object.values(IconLogo).includes(icon as IconLogo)) {
        if (logoEnv) {
            src += `logos_client/${icon}_${logoEnv.replaceAll(/\s/g, '').toLocaleLowerCase()}`;
        } else {
            src += `logos_lecab/${icon}`;
        }
    } else if (Object.values(IconService).includes(icon as IconService)) {
        const hasDarkMode = [IconService.Berline, IconService.Prestige, IconService.Van].includes(icon as IconService);
        src += `resources/products/services/${icon}${darkMode && hasDarkMode ? '_dark' : ''}`;
    } else if (Object.values(IconError).includes(icon as IconError)) {
        src += `resources/products/errors/${icon}`;
    } else if (Object.values(IconAxel).includes(icon as IconAxel)) {
        src += `resources/products/icons/axel/${icon}`;
    } else {
        src += `resources/products/icons/${icon}`;
    }
    src += '.svg';
    return src;
};

export const imageToCdn = (eventType: EventType, icon: ImageEvent): string => {
    const srcBase = envConfig.currentEnv.cdnURL;
    let src = srcBase;

    src += `resources/products/events/${eventType.toLocaleLowerCase()}/${icon}`;
    src += '.jpeg';
    return src;
};

// Animation
export const animationToCdn = (icon: Animation, darkMode: boolean = false): string => {
    const srcBase = envConfig.currentEnv.cdnURL;
    let src = srcBase;
    src += `resources/products/anims/${darkMode ? 'dark_' : ''}${icon}`;
    src += '.json';
    return src;
};

// Fetch animation from CDN and save in the Cache API
export const fetchAndCacheAnimation = async (url: string): Promise<string> => {
    const cacheName = 'lottie-animation-cache';

    // Open the browser's cache
    const cache = await caches.open(cacheName);

    // Check if the animation is already cached
    const cachedResponse = await cache.match(url);
    if (cachedResponse) {
        const cachedData = await cachedResponse.json();
        return cachedData;
    }

    // If not cached, fetch it from the CDN
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');

        const animationData = await response.clone().json();

        // Save the response in the cache for future use
        cache.put(url, response);

        return animationData;
    } catch (error) {
        console.error('Failed to fetch animation:', error);
        throw error;
    }
};
